/**
 * PATH: apps/qa/src/pages/record-detail/QaRecordItpLibrary.tsx
 * FILE_ID: QA-RECORD-ITP-LIBRARY-001
 * PURPOSE: Open the job ITP library from the QA record header.
 */
import { useEffect, useState } from 'react'
import { FileText } from 'lucide-react'
import { Dialog } from '@quotech/ui'
import { JobHubDataAdapterProvider } from '@quotech/job-hub/jobs/jobHubDataAdapter'
import { JobItpLibrary } from '@quotech/job-hub/jobs/tabs/JobItpLibrary'
import { useQaRecordDataAdapter } from './useQaRecordDataAdapter'

export function QaRecordItpLibrary({
  jobId,
  bindOpen,
}: {
  jobId: number
  bindOpen?: (open: () => void) => void
}) {
  const [open, setOpen] = useState(false)
  const { dataAdapter, numericOrgId } = useQaRecordDataAdapter()
  useEffect(() => {
    bindOpen?.(() => setOpen(true))
  }, [bindOpen])

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="hidden items-center gap-2 rounded-xl border border-input px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground md:inline-flex"
      >
        <FileText className="h-4 w-4" aria-hidden />
        ITP Library
      </button>
      <JobHubDataAdapterProvider adapter={dataAdapter}>
        {/* Reused from: packages/job-hub/src/jobs/tabs/JobItpLibrary.tsx (JobItpLibrary) */}
        <JobItpLibrary
          jobId={jobId}
          orgId={numericOrgId}
          variant="sheet"
          browsing={open}
          frame={(list) => (
            <Dialog open={open} onOpenChange={setOpen} title="ITP Library">
              {list}
            </Dialog>
          )}
        />
      </JobHubDataAdapterProvider>
    </>
  )
}
